import { LOADING, ERROR, CLEAR_ERRORS } from '../constants/globalConstants'
import {
  ADD_PLAYLIST,
  ADD_SONG_TO_PLAYLIST,
  EDIT_PLAYLIST,
  GET_PLAYLIST,
  GET_PUBLIC_PLAYLISTS,
  DELETE_PLAYLIST,
  REMOVE_SONG_FROM_PLAYLIST
} from '../constants/playlistConsants'

const playlistReducer = (state = {}, action) => {
  switch (action.type) {
    case CLEAR_ERRORS:
      return { ...state, loading: false, error: null }

    case LOADING:
      return { ...state, loading: true }

    case ERROR:
      return { ...state, loading: false, error: action.payload }

    case ADD_PLAYLIST:
      return { ...state, loading: false, error: null }

    case GET_PUBLIC_PLAYLISTS:
      return { ...state, loading: false, error: null, playlists: action.payload }

    case ADD_SONG_TO_PLAYLIST:
      return { ...state, loading: false, error: null }

    case GET_PLAYLIST:
      return { ...state, loading: false, error: null, playlist: action.payload }

    case EDIT_PLAYLIST:
      return { ...state, loading: false, error: null }

    case DELETE_PLAYLIST:
      return { ...state, loading: false, error: null, playlist: null }

    case REMOVE_SONG_FROM_PLAYLIST:
      return { ...state, loading: false, error: null }

    default:
      return state
  }
}

export default playlistReducer